module.exports = __webpack_public_path__ + "static/media/icon.cf0d5c68.png";